import { Grid, Stack } from "@mui/material";
import { Show, Tab, TabbedShowLayout } from "react-admin";
import WalletTransactionMetaShow from "./WalletTransactionMetaShow";

const RenderCTAButtons = (props: any) => {
  return (
    <Stack p={2}>
      <Grid container spacing={2} justifyContent="flex-end">
      </Grid>
    </Stack>
  );
};

const WalletTransactionTabShow = () => {

  return (
    <TabbedShowLayout>
      <Tab label={"Details"}>
        <WalletTransactionMetaShow/>
      </Tab>
    </TabbedShowLayout>
  );
};
const WalletTransactionsShow = (props: any) => {
  return (
    <div>
      <Show {...props} actions={false}>
        <RenderCTAButtons/>
        <WalletTransactionTabShow />
      </Show>
    </div>
  );
};
export default WalletTransactionsShow;